var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3,13 L7,13 L7,21 L3,21 L3,13 Z M9,3 L13,3 L13,21 L9,21 L9,3 Z M15,8 L19,8 L19,21 L15,21 L15,8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4CAF50",
    d: "M4,14 L6,14 L6,20 L4,20 L4,14 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC107",
    d: "M10,4 L12,4 L12,20 L10,20 L10,4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F44336",
    d: "M16,9 L18,9 L18,20 L16,20 L16,9 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.bf1e073aa36521b83c38fd91b9197cab.svg";
export { ForwardRef as ReactComponent };